import { render, staticRenderFns } from "./TrainCompositionSheet.vue?vue&type=template&id=4235b5ca&scoped=true&"
import script from "./TrainCompositionSheet.vue?vue&type=script&lang=js&"
export * from "./TrainCompositionSheet.vue?vue&type=script&lang=js&"
import style0 from "./TrainCompositionSheet.vue?vue&type=style&index=0&id=4235b5ca&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4235b5ca",
  null
  
)

export default component.exports